import { render, staticRenderFns } from "./ModelListView.vue?vue&type=template&id=0b6985ba&scoped=true&"
import script from "./ModelListView.vue?vue&type=script&lang=js&"
export * from "./ModelListView.vue?vue&type=script&lang=js&"
import style0 from "./ModelListView.vue?vue&type=style&index=0&id=0b6985ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6985ba",
  null
  
)

export default component.exports